<template>
    <CardRh :processando="processando" titulo="Configuracao Cadastradas">
        <div class="configuracao-index-page">
            <section class="filter-panel">
                <span class="panel-border-label">Filtros</span>

                <div class="row g-4">
                    <div class="col-12 col-md-6 col-lg-3">
                        <label for="pesquisaConfiguracao" class="form-label">Pesquisar</label>
                        <input id="pesquisaConfiguracao" v-model="search" class="form-control form-control-solid"
                            type="text" placeholder="Pesquisar por chave ou valor" @keyup="apertouEnter($event)">
                    </div>

                    <div class="col-12 col-lg-9 panel-actions">
                        <div>
                            <button type="button" class="btn btn-light btn-sm" @click="limparFiltros">
                                Limpar filtros
                            </button>
                            <button v-if="hasPermissao" type="button" class="btn btn-sm btn-pmes-primary"
                                title="Inserir" data-bs-toggle="modal" :data-bs-target="'#' + modal_cadastro">
                                <i class="fa fa-plus bi fs-2x"></i> <span>Inserir</span>
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            <section class="table-panel">
                <KDataTable :reload="reloadDatatable" :config="config" @tableatualizada="tableatualizada()"
                    :pesquisar="false">
                    <th style="max-width:90px">ID</th>
                    <th>Chave</th>
                    <th>Valor</th>
                    <th style="min-width:200px" class="text-center" v-if="hasPermissao">Ações</th>
                </KDataTable>
            </section>
        </div>
        <Turma :service="service" :modelo="modelo" :modal="modal_turma" :perfis="perfis" />
        <Cadastro :service="service" @configuracao-cadastrado="modeloAlterado" :modal="modal_cadastro"
            :perfis="perfis" />
        <Editar @update-configuracao-alterado="modeloAlterado" :service="service" :modelo="dados"
            :modal="modal_atualizar" v-if="hasPermissao" :perfis="perfis" />
    </CardRh>
</template>

<script lang="ts">
import IndexModelTable from '@/views/paginas/sigap/modelos/IndexModelTable.vue';
import CardRh from "@/components/cards/ManzaCard.vue";
import ConfiguracaoService from "@/service/v1/sigap/ConfiguracaoService";
import { Options } from "vue-class-component";
import SiteUtils from '@/assets/ts/aplicacao/site';
import KDataTable from "@/components/datatable/newdatatable.vue";
import $ from "jquery";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import Cadastro from "./_Cadastro.vue";
import Editar from "./_Editar.vue";

@Options({
    name: "ConfiguracaoIndex",
    components: { CardRh, KDataTable, Cadastro, Editar },
})
export default class ConfiguracaoIndex extends IndexModelTable {
    public modal_turma;
    public search = "";

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE], this.perfis);
    }

    get hasPermissaoAdmin(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() {
        this.search = "";
        this.refreshTable();
    }

    created() {
        this.service = new ConfiguracaoService();

        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    search: this.search || d.search.value
                };
                return dados;
            }
        };

        this.modal_turma = 'modal_configuracao_turma_';
        this.modal_atualizar = 'modal_configuracao_update_';

        this.config.columns = [
            { data: 'id', name: 'id', class: 'desktop' },
            { data: 'nome', name: 'nome' },
            { data: 'valor', name: 'valor', class: 'desktop' },
        ];
        if (this.hasPermissao) {
            this.pushColunaAcoes();
            this.config.columnDefs = [
                {
                    targets: 3,
                    render: (row, type, val, meta) => {
                        let texto = '';
                        let buttom = '';
                        for (const key in val) {
                            buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                        }
                        texto = texto + '<button class="btn btn-success btn-sm" btn-editar ' + buttom + '   data-bs-toggle="modal" data-bs-target="#' +
                            this.modal_atualizar + '"><i class="fa fa-edit"></i></button>';
                        if (this.hasPermissaoAdmin) {
                            texto = texto + '<button class="btn btn-pmes-danger btn-sm" btn-excluir ' + buttom + ' ><i class="fa fa-trash"></i> </button>';
                        }
                        return texto;
                    },
                }
            ];
        }
    }

    public tableatualizada() {
        $('[btn-editar]').click((btn) => {
            this.dados = null;
            setTimeout(() => {
                this.dados = $(btn.currentTarget).data();
            }, 10);
        });
        $('[btn-excluir]').click((btn) => {
            const id = $(btn.currentTarget).data('id');
            this.excluirModelo(id);
        });
    }
}
</script>

<style scoped>
.configuracao-index-page {
    display: grid;
    gap: 24px;
}

.filter-panel,
.table-panel {
    border: 1px solid #e5edf6;
    border-radius: 22px;
    background: linear-gradient(180deg, #ffffff 0%, #f9fbfd 100%);
    padding: 15px;
}

.filter-panel {
    position: relative;
    padding-top: 24px;
}

.panel-border-label {
    position: absolute;
    top: -9px;
    left: 18px;
    padding: 0 10px;
    background: #ffffff;
    color: #102542;
    font-size: 0.95rem;
    font-weight: 800;
    line-height: 1.4;
}

.panel-actions {
    text-align: end;
    margin-top: 20px;
}

.table-panel {
    padding: 2px 10px !important;
}

.btn-sm {
    margin-left: 10px;
    padding: 0.55rem 1.25rem;
}

.registro-alteracao {
    text-align: right;
}

@media screen and (max-width: 991px) {

    .filter-panel,
    .table-panel {
        padding: 18px;
        border-radius: 18px;
    }

    .filter-panel {
        padding-top: 26px;
    }

    .panel-actions {
        text-align: left;
        margin-top: 0;
    }
}
</style>
